/*
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by Shivam Mishra <shivam.mishra@wakencode.com>, 6 2023
 *
 */

import { AntUpload } from "../../../antd";
import type { UploadChangeParam, UploadFile } from "antd/es/upload/interface";
import type { RcFile } from "antd/es/upload";
import { useState } from "react";
import { ImageViewer } from "../../../pages/common/imageViewer";
import { downloadImageFromUrl } from "../../../../utility/helper";

export interface IImageUploadComponent {
  fileList: UploadFile[];
  handleChange: (info: UploadChangeParam<UploadFile<any>>) => void;  
  maxCount?: number;
}

const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export const ImageUpload = ({
  fileList,
  handleChange,  
  maxCount = Infinity, // Default value is Infinity (i.e., no limit)
}: IImageUploadComponent) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file: UploadFile) => {
    console.log(file);
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleDownloadImage = (index: number) => {
    const file = fileList[index];
    downloadImageFromUrl(file.url as string, file.name);
  };

  return (
    <>
      {previewOpen && (
        <ImageViewer
          onClose={handleCancel}
          fileList={fileList}
          currentOpen={fileList.findIndex((item) => item.url === previewImage)}          
          onDownload={(index) => handleDownloadImage(index)}
        />
      )}

      <div style={{ margin: "8px 0" }}>
        {(fileList.length < maxCount || fileList.length > 0) && (
          <AntUpload
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            showUploadList={{showRemoveIcon: false}}
            onChange={handleChange}
            multiple={true}
            accept="image/png, image/jpg, image/jpeg, image/tiff"
            beforeUpload={(file: RcFile, FileList: RcFile[]) => {
              return false;
            }}            
          >
            {/* {fileList.length < maxCount && uploadButton} */}
          </AntUpload>
        )}
      </div>
    </>
  );
};
